module.exports = __webpack_public_path__ + "img/about_zhCn.22d85bb1.png";